import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import SectionTitle from "../../components/Shared/SectionTitle";

//Import Images
import mobile from "../../assets/images/software/SıraKayırFormu.png";

class WebsiteDescription extends Component {

  render() {
    return (
      <React.Fragment>
        <Container id="baslangic" className="mt-100 mt-60">
          {/* Render Section Title */}
          <SectionTitle
            title="3 Adımda Başlayın"
            desc="Dijital Sıramatik ile işletmenizi dijitalleştirmek çok kolay. Sadece birkaç dakika içinde başlayabilirsiniz."
          />

          <Row className="align-items-center mt-5">
            <Col lg="5" md="6">
              <img src={mobile} className="img-fluid" alt="Dijital Sıramatik Nasıl Çalışır" />
            </Col>

            <Col lg="7" md="6" className="mt-4 mt-sm-0 pt-2 pt-sm-0">
              <div className="section-title ms-lg-5">
                <h4 className="title mb-4">Adım 1: Kurulum</h4>
                <p className="text-muted">Hesabınızı oluşturun ve temel ayarlarınızı yapın. Firma bilgilerinizi, logo ve tema renklerinizi yükleyin. Hizmet çeşitlerinizi tanımlayın, odalarınızı ve personellerinizi ekleyin.</p>
                <ul className="list-unstyled mb-0 text-muted">
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Firma bilgilerinizi girin</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Logo ve tema renklerinizi yükleyin</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Hizmet çeşitlerinizi tanımlayın</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Odalarınızı ve personellerinizi ekleyin</li>
                </ul>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center mt-5">
            <Col lg="7" md="6" className="order-2 order-lg-1">
              <div className="section-title me-lg-5">
                <h4 className="title mb-4">Adım 2: Kiosk Kurulumu</h4>
                <p className="text-muted">Kiosk ekranınızı hazırlayın. Tablet veya dokunmatik ekranı kiosk moduna alın, QR kod ekranını müşterilerinizin görebileceği yere yerleştirin ve TV Display ekranını bekleme salonuna kurun.</p>
                <ul className="list-unstyled mb-0 text-muted">
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Tablet veya dokunmatik ekranı kiosk moduna alın</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>QR kod ekranını yerleştirin</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>TV Display ekranını bekleme salonuna kurun</li>
                </ul>
              </div>
            </Col>
            <Col lg="5" md="6" className="order-1 order-lg-2 mt-4 mt-lg-0">
              <img src={mobile} className="img-fluid" alt="Kiosk Kurulumu" />
            </Col>
          </Row>

          <Row className="align-items-center mt-5">
            <Col lg="5" md="6">
              <img src={mobile} className="img-fluid" alt="Sistem Hazır" />
            </Col>
            <Col lg="7" md="6" className="mt-4 mt-sm-0 pt-2 pt-sm-0">
              <div className="section-title ms-lg-5">
                <h4 className="title mb-4">Adım 3: Kullanmaya Başlayın</h4>
                <p className="text-muted">Sistem hazır! Müşterileriniz QR kod okutarak sıra alabilir, personeliniz dashboard'dan hasta çağırabilir. Tüm işlemler otomatik olarak kaydedilir.</p>
                <ul className="list-unstyled mb-0 text-muted">
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Müşterileriniz QR kod okutarak sıra alabilir</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Personeliniz dashboard'dan hasta çağırabilir</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Tüm işlemler otomatik olarak kaydedilir</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default WebsiteDescription;
